// src/pages/Settings.js
import React, { useState } from "react";
import "../styles/Settings.css";

const Settings = () => {
  const tabs = [
    { key: "Profile", label: "Profile", icon: "👤" },
    { key: "System", label: "System", icon: "⚙️" },
    { key: "Staff", label: "Staff", icon: "👥" },
    { key: "Security", label: "Security", icon: "🔒" },
  ];

  const [activeTab, setActiveTab] = useState("Profile");

  // 🔹 States
  const [profile, setProfile] = useState({ name: "John Doe", email: "admin@cjet.com" });
  const [editing, setEditing] = useState(false);

  const [system, setSystem] = useState({ currency: "USD", basePrice: 10 });

  const [staff, setStaff] = useState([
    { id: 1, name: "Jane Smith", role: "Admin" },
    { id: 2, name: "Chris Johnson", role: "Support" },
  ]);
  const [newStaff, setNewStaff] = useState({ name: "", role: "Support" });
  const [showAddStaff, setShowAddStaff] = useState(false);

  const [security, setSecurity] = useState({ twoFactor: true, apiKey: "sk_live_xxxxxx" });

  // 🔹 Mock Save Functions
  const handleProfileUpdate = (e) => {
    e.preventDefault();
    setEditing(false);
    alert(`Profile updated: ${profile.name}, ${profile.email}`);
    console.log("Saved profile:", profile);
  };

  const saveSystemSettings = () => {
    alert(`System settings saved: ${system.currency}, Base Price ${system.basePrice}`);
    console.log("Saved system:", system);
  };

  const handleAddStaff = (e) => {
    e.preventDefault();
    const newEntry = { ...newStaff, id: Date.now() };
    setStaff([...staff, newEntry]);
    setNewStaff({ name: "", role: "Support" });
    setShowAddStaff(false);
    alert("Staff added!");
    console.log("Staff list:", staff);
  };

  const regenerateApiKey = () => {
    const newKey = "sk_live_" + Math.random().toString(36).substring(2, 12);
    setSecurity({ ...security, apiKey: newKey });
    alert("API Key regenerated!");
    console.log("New API Key:", newKey);
  };

  // 🔹 Render Sections
  const renderContent = () => {
    switch (activeTab) {
      case "Profile":
        return (
          <div className="settings-section">
            <h2>👤 Profile Settings</h2>
            <div className="mock-card">
              <img src="https://via.placeholder.com/80" alt="Profile" className="mock-avatar" />
              <div>
                <p><strong>Name:</strong> {profile.name}</p>
                <p><strong>Email:</strong> {profile.email}</p>
                <button className="primary-btn" onClick={() => setEditing(true)}>Edit Profile</button>
              </div>
            </div>

            {editing && (
              <form onSubmit={handleProfileUpdate} style={{ marginTop: "15px" }}>
                <input
                  type="text"
                  value={profile.name}
                  onChange={(e) => setProfile({ ...profile, name: e.target.value })}
                  placeholder="Full Name"
                />
                <input
                  type="email"
                  value={profile.email}
                  onChange={(e) => setProfile({ ...profile, email: e.target.value })}
                  placeholder="Email"
                />
                <button className="primary-btn" type="submit">Save</button>
              </form>
            )}
          </div>
        );

      case "System":
        return (
          <div className="settings-section">
            <h2>⚙️ System Settings</h2>
            <div className="mock-toggle">
              <label>
                Default Currency:
                <select
                  value={system.currency}
                  onChange={(e) => setSystem({ ...system, currency: e.target.value })}
                >
                  <option value="USD">USD ($)</option>
                  <option value="EUR">EUR (€)</option>
                  <option value="NGN">NGN (₦)</option>
                </select>
              </label>
              <label>
                Shipment Base Price:
                <input
                  type="number"
                  value={system.basePrice}
                  onChange={(e) => setSystem({ ...system, basePrice: e.target.value })}
                /> {system.currency}
              </label>
              <button className="primary-btn" onClick={saveSystemSettings}>Save Changes</button>
            </div>
          </div>
        );

      case "Staff":
        return (
          <div className="settings-section">
            <h2>👥 Staff Management</h2>
            <ul className="mock-list">
              {staff.map((member) => (
                <li key={member.id}>
                  {member.name} <span className="badge">{member.role}</span>
                </li>
              ))}
            </ul>
            <button className="primary-btn" onClick={() => setShowAddStaff(true)}>+ Add Staff</button>

            {showAddStaff && (
              <form onSubmit={handleAddStaff} style={{ marginTop: "15px" }}>
                <input
                  type="text"
                  placeholder="Staff Name"
                  value={newStaff.name}
                  onChange={(e) => setNewStaff({ ...newStaff, name: e.target.value })}
                  required
                />
                <select
                  value={newStaff.role}
                  onChange={(e) => setNewStaff({ ...newStaff, role: e.target.value })}
                >
                  <option value="Admin">Admin</option>
                  <option value="Support">Support</option>
                </select>
                <button className="primary-btn" type="submit">Save</button>
              </form>
            )}
          </div>
        );

      case "Security":
        return (
          <div className="settings-section">
            <h2>🔒 Security Settings</h2>
            <div className="mock-toggle">
              <label>
                Two-Factor Authentication:
                <input
                  type="checkbox"
                  checked={security.twoFactor}
                  onChange={() => setSecurity({ ...security, twoFactor: !security.twoFactor })}
                />
              </label>
              <label>
                API Key:
                <input type="text" value={security.apiKey} readOnly />
                <button className="primary-btn" onClick={() => navigator.clipboard.writeText(security.apiKey)}>Copy</button>
              </label>
              <button className="primary-btn" onClick={regenerateApiKey}>🔄 Regenerate Key</button>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="settings-container">
      {/* Horizontal Tab Bar with icons */}
      <div className="settings-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`tab-btn ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => setActiveTab(tab.key)}
          >
            <span className="tab-icon">{tab.icon}</span> {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="settings-content">{renderContent()}</div>
    </div>
  );
};

export default Settings;
